// Add your custom JS here.
jQuery(function($) {
    $(document).ready(function(){
        document.documentElement.style.setProperty('--child-theme-scrollbar-width', (window.innerWidth - document.documentElement.clientWidth) + "px");

        var isBreakPoint = function (bp) {
            var bps = [768, 992, 1200, 1880],
                w = $(window).width(),
                min, max
            for (var i = 0, l = bps.length; i < l; i++) {
              if (bps[i] === bp) {
                min = bps[i-1] || 0
                max = bps[i]
                break
              }
            }
            return w > min && w <= max
        }

        var isBreakPointUp = function (bp) {
            var w = $(window).width();
            return w >= bp;
        }


        // Prevent dropdown togglers from closing the menu
        $(".navbar-collapse").click(function(event){
            event.stopPropagation();
        });

        // When a submenu is toggled:
        $("#navbarNavDropdown .dropdown-toggle").on('click', function (e) {
            // If its being switched on
            if($(this).hasClass('show')) {
                // Close other submenus
                $(this).parent().siblings("li").children().removeClass('show');
            }

    //        e.stopPropagation();
    //        e.preventDefault();
        });
        // When a first tier submenu is toggled:
        $("#navbarNavDropdown > ul > li > .dropdown-toggle").on('click', function (e) {
            if($("#navbarNavDropdown > ul > li > .dropdown-toggle.show").length >= 1)  $("#menu-suplemental").addClass('show');
            else $("#menu-suplemental").removeClass('show');
        });

        // Close dropdown when user clicks outside menu
        $(window).click(function(e) {
            if($("#navbarNavDropdown > ul > li > .dropdown-toggle.show").length >= 1 || $("#menu-suplemental.show").length >=1) {
                $("#navbarNavDropdown > ul > li > .dropdown-toggle").removeClass('show');
                $("#menu-suplemental").removeClass('show');
                e.preventDefault();
            }
        });


        // Desktop Hover Menu Behaviours
/*
        function initiateHoverMenuBehaviours() {
            // Un-initialise Slick
            if (isBreakPointUp(1200)) {
                // When a first tier menu item gets hover state
                $("#navbarNavDropdown > ul > li.dropdown").on('mouseenter', function (e) {
                    $("#navbarNavDropdown > ul > li.dropdown > ul.dropdown-menu").removeClass('show');
                    $(this).children("ul.dropdown-menu").addClass('show');
                    $("#menu-suplemental").addClass('show');
                });
                $("#navbarNavDropdown > ul > li.dropdown, #menu-suplemental").on('mouseleave', function (e) {
                    if ($("#navbarNavDropdown > ul > li:hover").length == 0 && $("#menu-suplemental:hover").length == 0) {
                        $("#navbarNavDropdown > ul > li.dropdown > ul.dropdown-menu").removeClass('show');
                        $("#menu-suplemental").removeClass('show');
                    }
                });
            }
            else {
                $("#navbarNavDropdown > ul > li.dropdown").off('mouseenter');
                $("#navbarNavDropdown > ul > li.dropdown, #menu-suplemental").off('mouseleave');
            }
        }
*/
        function initiateHoverMenuBehaviours() {
            // Un-initialise Slick
            if (isBreakPointUp(1200)) {
                // When a first tier menu item gets hover state
                $("#navbarNavDropdown ul li.dropdown").on('mouseenter', function (e) {
                    $(this).siblings("li.dropdown").children("ul.dropdown-menu").removeClass('show');
                    $(this).children("ul.dropdown-menu").addClass('show');
                    $("#menu-suplemental").addClass('show');
                });
                $("#navbarNavDropdown > ul > li.dropdown, #menu-suplemental").on('mouseleave', function (e) {
                    if ($("#navbarNavDropdown > ul > li:hover").length == 0 && $("#menu-suplemental:hover").length == 0) {
                        $("#navbarNavDropdown > ul > li.dropdown > ul.dropdown-menu").removeClass('show');
                        $("#menu-suplemental").removeClass('show');
                    }
                });
            }
            else {
                $("#navbarNavDropdown ul li.dropdown").off('mouseenter');
                $("#navbarNavDropdown ul li.dropdown, #menu-suplemental").off('mouseleave');
            }
        }
        initiateHoverMenuBehaviours();


        // Change header class when navbar is toggled
        // Turns header white, hides search icon etc
        $(".navbar-toggler").click(function(event){
          $(this).parents("header#wrapper-navbar").toggleClass('menu-expanded');
        });

        // Our Board prevent all items closing
        const accordions = document.querySelectorAll("#our-board-inner.accordion");
        let opening = false;
        accordions.forEach(function (el) {
          el.addEventListener("hide.bs.collapse", (event) => {
            if (!opening) {
              event.preventDefault();
              event.stopPropagation();
            } else {
              opening = false;
            }
          });
          el.addEventListener("show.bs.collapse", (event) => {
            opening = true;
          });
        });

        // Our Board responsive behaviours
        function initiateOurBoardBehaviours() {
            // Un-initialise Slick

            if (isBreakPointUp(992)) {
                $(".our-board-content").removeClass('collapse');
                $(".our-board-member").addClass('collapse');
                $(".our-board-member").addClass('fade');
                $(".our-board-member:first-child").addClass('show');
                $(".our-board-header a").attr('data-bs-toggle','');
                $(".our-board-header a").addClass('disabled');

                // Initialise Slick
                if($(".our-board-carousel.slick-initialized").length==0) {
                    $(".our-board-carousel").slick({
                        infinite: false,
                        slidesToShow: 2,
                        slidesToScroll: 1,
                        vertical: true,
                        verticalSwiping: true,
                        prevArrow: '<button class="btn slick-prev" type="button"></span><span class="visually-hidden">Previous</span></button>',
                        nextArrow: '<button class="btn slick-next" type="button"></span><span class="visually-hidden">Next</span></button>',
                    });
                    $(".our-board-carousel").slick('slickFilter',':not([data-slick-index="0"])');
                }
                else {
                    $(".our-board-carousel").slick('slickUnfilter');
                    $(".our-board-carousel").slick('slickFilter',':not([data-slick-index="0"])');
                }

            }
            else {
                $(".our-board-content").addClass('collapse');
                $(".our-board-member").removeClass('collapse');
                $(".our-board-member").removeClass('show');
                $(".our-board-member").removeClass('fade');
                $(".our-board-header a").attr('data-bs-toggle','collapse');
                $(".our-board-header a").removeClass('disabled');
            }
        }
        initiateOurBoardBehaviours();
        $(".our-board-header a.disabled").click(function(event){
            event.preventDefault();
        });
        function addOurBoardListener() {
            $("a.our-board-toggle-link").off('click');
            $("a.our-board-toggle-link").click(function(event){
                var nth = $(this).parent().attr('data-slick-index');
                $(".our-board-carousel").slick('slickUnfilter');
                $(".our-board-carousel").slick('slickFilter',':not([data-slick-index="'+nth+'"])');
                addOurBoardListener();
            });
        }
        addOurBoardListener();

        function moveOurBoardSubMenu() {
            $("#sidebar-sub-menu li.current_page_item").append( $("#our-board-sub-nav > ul") );
        }
        moveOurBoardSubMenu();

/*
$('#our-board-inner .collapse').each((i, e) =>
    $(e).on('hidden.bs.collapse', () => {
        // check if an accordion item is expanded
        let isExpanded = false;
        $('#our-board-inner [aria-expanded]').each((i, element) => {
            if ($(element).attr("aria-expanded") === 'true') {
                isExpanded = true;
            }
        });
alert('Expanded: '+isExpanded);
        // show the first accordion item
        if (!isExpanded) {
alert('Click?');
            $('#our-board-first-accordion-btn').click();
        }
    })
);
*/




        // Mobile Only Accordion responsive behaviours
        function initiateMobileOnlyAccordionBehaviours() {
            // Un-initialise Slick

            if (isBreakPointUp(992)) {
                $(".mobile-only-accordion-content").removeClass('collapse');
                $(".mobile-only-accordion-header a").attr('data-bs-toggle','');
                $(".mobile-only-accordion-header a").addClass('disabled');
                $(".mobile-only-accordion-header a").removeClass('collapsed');
            }
            else {
                $(".mobile-only-accordion-content").addClass('collapse');
                $(".mobile-only-accordion-header a").attr('data-bs-toggle','collapse');
                $(".mobile-only-accordion-header a").removeClass('disabled');
                $(".mobile-only-accordion-header a").addClass('collapsed');
            }
        }
        initiateMobileOnlyAccordionBehaviours();

        // Mobile Only Tabs responsive behaviours
        function initiateMobileOnlyTabsBehaviours() {
            // Un-initialise Slick
//console.log(isBreakPointUp(992));
            if (isBreakPointUp(992)) {
                $("#our-properties-mobile-tab-content").removeClass('tab-content');
            }
            else {
                $("#our-properties-mobile-tab-content").addClass('tab-content');
            }
        }
        initiateMobileOnlyTabsBehaviours();


        $(window).on("resize", function() {
            initiateHoverMenuBehaviours();
            initiateOurBoardBehaviours();
            initiateMobileOnlyAccordionBehaviours();
            initiateMobileOnlyTabsBehaviours();
        });


        $("#aireit-gateway-button").click(function(e) {
            e.preventDefault();
            setCookie('aireit-gateway-allowed-front', 1, 30);
            $("#aireit-gateway-modal-wrapper").css('display','none');
        });

        $("#gateway-country").on('change', function()
        {
            var select = $(this);
            var allowed = $(this).val();
            var disclaimer_intro = $('.disclaimer-intro');
            var gate_content = $('.gate-content');
            var view_disclaimer = $('.gate-content .button-link.disclaimer').parent();
            var disclaimer_content = $('.disclaimer-content');
            var denied_content = $('.denied-content');

            if (allowed === 'yes')
            {
                denied_content.attr('hidden', 'hidden');
                view_disclaimer.removeAttr('hidden');
                view_disclaimer.find('.button-link.disclaimer').on('click', function()
                {
                    disclaimer_intro.attr('hidden', 'hidden');
                    select.attr('hidden', 'hidden');
                    view_disclaimer.attr('hidden', 'hidden')
                    disclaimer_content.removeAttr('hidden');

                    disclaimer_content.find('.no-agree').on('click', function(e) {
                        e.preventDefault();
                        view_disclaimer.attr('hidden', 'hidden');
                        gate_content.attr('hidden', 'hidden');
                        disclaimer_content.attr('hidden', 'hidden');
                        denied_content.removeAttr('hidden');
                    })


                    disclaimer_content.find('.button-link.go').on('click', function() {
                        setCookie('aireit-gateway-allowed', 1, 30);
                        var href = $('#documents-nav-list a.active').attr('href');
//                        location.reload();
                        location.href = href;
                    })
                })
            } else {
                view_disclaimer.attr('hidden', 'hidden');
                denied_content.removeAttr('hidden');
            }
        })

        function setCookie(cname, cvalue, exdays) {
            var d = new Date();
            d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
            var expires = "expires=" + d.toUTCString();
            document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
        }

        function getCookie(cname) {
            var name = cname + "=";
            var decodedCookie = decodeURIComponent(document.cookie);
            var ca = decodedCookie.split(';');
            for (var i = 0; i < ca.length; i++) {
                var c = ca[i];
                while (c.charAt(0) == ' ') {
                    c = c.substring(1);
                }
                if (c.indexOf(name) == 0) {
                    return c.substring(name.length, c.length);
                }
            }
            return "";
        }

//        $('table.tablepress').wrap('<div class="table-wrapper"></div>');



        $(".icon-back-to-top").click(function(e) {
            e.preventDefault();
            window.scrollTo(0, 0);
        });


        // Force iFrame Height
/*
        window.addEventListener('message', function(e) {
          var $iframe = $("#main iframe");
          var eventName = e.data[0];
          var data = e.data[1];
          switch(eventName) {
            case 'setHeight':
              $iframe.height(data);
              break;
            case 'setWidth':
              $iframe.width(data);
//alert(data);
              break;
          }
        }, false);
*/
    });

});
